import { TableColumn, TableConfig } from "src/app/@shared/models/table.models";



export const GENERATE_WITH_AI_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "name",
        header: "Document Name",
        type: "custom",
        template: "documentNameTemplate",
        width: "20%"
    },
    {
        field: "projectName",
        header: "Project",
        type: "custom",
        template: "projectTemplate",
        width: "15%"
    },
    {
        field: "linkedDocType",
        header: "Document Type",
        type: "custom",
        template: "documentTypeTemplate",
        width: "15%"
    },
    {
        field: "createdBy",
        header: "Created By",
        type: "custom",
        template: "createdByTemplate",
        width: "15%"
    },
    {
        field: "documentStatus",
        header: "Status",
        type: "custom",
        template: "statusTemplate",
        width: "12%"
    },
    {
        field: "dueDate",
        header: "Due Date",
        type: "custom",
        template: "dueDateTemplate",
        width: "13%"
    },
    {
        field: "createdAt",
        header: "Created",
        type: "custom",
        template: "dateCreatedTemplate",
        width: "12%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "8%"
    }
];



export const GENERATE_WITH_AI_TABLE_CONFIG: TableConfig = {
    selectable: false,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No documents found",
    globalFilter: false,
    responsive: true
};
